import { render, staticRenderFns } from "./email-template-selection.vue?vue&type=template&id=cb691228&scoped=true&"
import script from "./email-template-selection.vue?vue&type=script&lang=js&"
export * from "./email-template-selection.vue?vue&type=script&lang=js&"
import style0 from "./email-template-selection.vue?vue&type=style&index=0&id=cb691228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb691228",
  null
  
)

export default component.exports